import React, { useEffect, useState } from 'react';
import { Table, Typography, Button, Form, Input, message, Space, Card, Segmented, Popconfirm } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import { REGEX, LAMBDAS } from "../../literals";
import { queueDropdown } from '../../assets/queueDropdown';
import { capacityDropdown } from '../../assets/capacityDropdown';
import useCancelCallback from "../../hooks/useCancelCallback";
import axios from 'axios';
import 'antd/dist/reset.css';
import './Dashboard.css'; // Import the CSS file
const { TextArea } = Input;

const { Title } = Typography;

const dummyData = [
  {
    key: '1',

    QueueName: 'HSA',
    PhoneNumber: '+1234567890',
    DateEnqueue: '00:05:32',
    Position: '1'
  },
  {
    key: '2',
    QueueName: 'Red',
    PhoneNumber: '+1987654321',
    DateEnqueue: '00:02:15',
    Position: '2'
  },
  {
    key: '3',
    QueueName: 'Purple',
    PhoneNumber: '+1987654321',
    DateEnqueue: '00:02:17',
    Position: '3'
  },
  {
    key: '4',
    QueueName: 'Green',
    PhoneNumber: '+1987654321',
    DateEnqueue: '00:02:15',
    Position: '4'
  },
  {
    key: '5',
    QueueName: 'Blue',
    PhoneNumber: '+1787654321',
    DateEnqueue: '00:02:15',
    Position: '5'
  },
  {
    key: '6',
    QueueName: 'Purple',
    PhoneNumber: '+1202654321',
    DateEnqueue: '00:40:15',
    Position: '6'
  },
  {
    key: '7',
    QueueName: 'IR',
    PhoneNumber: '+1887654321',
    DateEnqueue: '00:40:15',
    Position: '7'
  },
  {
    key: '8',
    QueueName: 'Geen',
    PhoneNumber: '+17041654321',
    DateEnqueue: '00:40:15',
    Position: '8'
  },
  {
    key: '9',
    QueueName: 'Red',
    PhoneNumber: '+13501654321',
    DateEnqueue: '00:40:15',
    Position: '9'
  },
  {
    key: '10',
    QueueName: 'HSA',
    PhoneNumber: '+12301654321',
    DateEnqueue: '00:40:15',
    Position: '10'
  },
];

var dict1 = {
  "Red Queue": "nHFsGsaTdhjUAfvsW",
  "Green Queue": "yYGHhUdaTaJiKhaHN",
  "Blue Queue": "sTjWsQcBaEHdRgDhG",
  "IR Queue": "hYnTAdYdYYWsdYjYA",
  "DCF Inbound Queue English": "aYAdYwdBnudYaWdTtJ",
  "Purple Queue": "bEhRbHshJdQsHsHaN",
  "LIEAP Queue": "HhjGbWHhJdMGHhHYa",
  "EmploymentServices": "EjHwgWHhJJwRUgQfS",
  "TEST": "gfj6hjyfHjRcg6Yvb"
};

const Dashboard = (props) => {
  // const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');

  const textArea = "amount";
  const queueArea = "queue";
  const capacityArea = "capacityType";
  const [textValue, setTextValue] = useState("");
  const [selectedValue1, setSelectedValue1] = useState("General");
  const [selectedOption, setSelectedOption] = useState("");
  const [phoneValue, setPhoneValue] = useState("");
  const [amountValue, setAmountValue] = useState("");
  const [queueValue, setQueueValue] = useState("");
  const [contactID, setContactID] = useState("");
  // const [routingProfile, setRoutingProfile] = useState("");
  // const [agentID, setAgentID] = useState("");
  const agentID = props.agentID;
  const xId = props.xId;
  const routingProfile = props.routingProfile;
  // const [xId, setXId] = useState("");
  const [searchMode, setSearchMode] = useState("contains");
  const [form] = Form.useForm();
  const [payLoad, setpayLoad] = useState(null);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [isSpanish, setIsSpanish] = useState(false);
  const [objValue, setObject] = useState({});
  const [isFirstLoad, setIsFirstLoad] = useState(false)
  const [isRefreshing, setIsRefreshing] = useState(false)
  const [progValue, setProgValue] = useState("select queue");
  const [capacityTypeVal, setCapacityTypeVal] = useState("temporary");
  const [programValue, setProgramValue] = useState();
  const [progLink, setProgLink] = useState("");
  const [caseNumber, setCaseNumber] = useState("")

  const [dataSource, setDataSource] = useState([])

  // window.addEventListener(
  //   "agentEvent",
  //   async function (e) {
  //     var agentID = e.detail.id;
  //     var xID = e.detail.xID;

  //     setAgentID(agentID);
  //     setXId(xID);
  //   },
  //   false
  // );

  useEffect(() => {
    // Set up an interval to refresh every 1 minute (60,000 ms)
    const intervalId = setInterval(() => {
      setIsRefreshing(true)
    }, 60000);

    // Clean up the interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (!isFirstLoad || isRefreshing) {
      console.log("AGENTID: ", agentID)
      axios({
        method: 'POST',
        baseURL: LAMBDAS.CURRENT_CALLBACKS,
        headers: { authorizationToken: agentID },
        data: {},
      }).then((response) => {
        console.log("RESPONSE DATA: ", response.data.body)

        setDataSource(response.data.body)

      }).catch((error) => {
        console.log(error);
      });
      setIsFirstLoad(true)
      setIsRefreshing(false)
    }

  }, [isFirstLoad, isRefreshing])

  const onFinish = () => {
    // var newPayload = {
    //   amount: form.getFieldValue(textArea),
    //   queue: form.getFieldValue(queueArea),
    //   capacityType: form.getFieldValue(capacityArea),
    //   closeQueues: false
    //   // agentID: agentID,
    //   // xID: xId,
    // };

    // console.log("NEW PAYLOAD: ", newPayload)
    // if (validateAmount(amountValue) && queueValue.length) {
    //   console.log("AMT AREA PAYLOAD: ", amountValue);
    //   console.log("QUE Area PAYLOAD: ", queueValue);
    //   //setpayLoad(ConvertToFormUrlEncoded(form.getFieldsValue()));
    //   var newPayload = {
    //     amount: form.getFieldValue(textArea),
    //     queue: form.getFieldValue(queueArea),
    //     capacityType: form.getFieldValue(capacityArea),
    //     closeQueues: false
    //     // agentID: agentID,
    //     // xID: xId,
    //   };
    //   setpayLoad(newPayload);
    //   setAmountValue("")
    //   setQueueValue("")
    //   setProgValue("select queue")
    //   setProgramValue("")
    //   setCapacityTypeVal("temporary")
    //   form.setFieldsValue({
    //     amount: "",
    //     queue: "",
    //     capacityType: "temporary",
    //     closeQueues: false
    //   });
    //   console.log("FORM VALUE: ", form);
    //   console.log("New Payload: ", newPayload);
    //   setIsRefreshing(true)
    // }
  };

  const onFinishFailed = () => {
    message.error("Please fill required fields.");
  };

  const onClear = () => {
    setObject({});
    setAmountValue("");
    setQueueValue("")
    setProgLink("");
    setProgValue("");
    setCapacityTypeVal("temporary")
    setSelectedOption("");
    setIsSpanish(false);
    form.setFieldsValue({
      amount: "",
      queue: "",
      capacityType: "temporary",
      closeQueues: false
    });
  };


  const handleUpdate = (e) => {
    setAmountValue(e.target.value)
    var textAreaMessage = e.target.value;
    console.log("MESSAGE: ", textAreaMessage)
    var updatedMessage = selectedOption + "\n" + textAreaMessage;
    console.log(updatedMessage);
    setIsSpanish(false);
    form.setFieldsValue({
      amount: textAreaMessage,
    });
  }




  function CapacityList(props) {
    console.log("PROPS CAPACITY LIST: ", props)
    function onDropChangeCapacity(event) {
      const { value } = event.target;
      console.log("ON Capacity Type CHANGE ENGAGED");

      // find the program with the current selected value
      const type = props.type.find((c) => c.name === value);
      console.log("capacity type value: ", type.value)



      if (type !== undefined) {
        setCapacityTypeVal(type.value)
        // use selected program object here
        form.setFieldsValue({
          capacityType: type.value
        });
      }
    }

    return (
      <>
        <input
          list="capacity"

          name="options"
          placeholder={capacityTypeVal}
          onChange={onDropChangeCapacity}
        />
        <datalist id="capacity">
          {props.type.map((type) => (
            <option
              key={type.value}
              data-value={type.value}
              value={type.name}
            />
          ))}
        </datalist>
      </>
    );
  }



  function DataList(props) {
    console.log("PROPS DATA LIST: ", props)
    function onDropChange(event) {
      const { value } = event.target;
      console.log("ON DROP CHANGE ENGAGED");

      // find the program with the current selected value
      const program = props.programs.find((c) => c.name === value);
      console.log("program value: ", program.value)



      if (program !== undefined) {
        setQueueValue(program.value)
        // use selected program object here
        setProgramValue(program.value);
        setProgValue(program.value);
        form.setFieldsValue({
          queue: program.value
        });
      }
    }

    return (
      <>
        <input
          list="dropdown"

          name="options"
          placeholder={progValue}
          onChange={onDropChange}
        />
        <datalist id="dropdown">
          {props.programs.map((program) => (
            <option
              key={program.value}
              data-value={program.value}
              value={program.name}
            />
          ))}
        </datalist>
      </>
    );
  }

  const columns = [
    {
      title: 'TANF/CC/FA App',
      dataIndex: 'red',
      key: 'red',
    },
    {
      title: 'FA App',
      dataIndex: 'green',
      key: 'green',
    },
    {
      title: 'Review',
      dataIndex: 'blue',
      key: 'blue',
    },
    {
      title: 'Interim Report',
      dataIndex: 'ir',
      key: 'ir',
    },
    {
      title: 'Change/Verification',
      dataIndex: 'purple',
      key: 'purple',
    },
    {
      title: 'Triage/Support',
      dataIndex: 'hsa',
      key: 'hsa',
    },
    {
      title: 'LIEAP Queue',
      dataIndex: 'lieap',
      key: 'lieap',
    },
  ];

  const fetchData = async () => {
    setLoading(true);
    try {
      //const response = await axios.get('YOUR_API_GATEWAY_INVOKE_URL');
      //const queueData = response.data.map((item, index) => ({
      //key: index,
      //Position: index + 1,
      //...item,
      //}));

      // setData(dummyData);
    } catch (error) {
      console.error('Error fetching data', error);
    }
    setLoading(false);
  };
  useEffect(() => {
    // Simulating data fetch
    setLoading(false);
    // setData(dummyData);
  }, []);

  const handleRemove = (key) => {
    let callbackRecord = dataSource.find(item => item.ContactID === key);
    let payload = {
      id: callbackRecord.ContactID,
      phone: callbackRecord.PhoneNumber,
      queueName: dict1[callbackRecord.QueueName]
    }
    console.log("PAYLOAD TO REMOVE: ", payload)
    axios({
      method: 'POST',
      baseURL: LAMBDAS.CANCEL_CALLBACK,
      headers: { authorizationToken: agentID },
      data: payload,
    }).then((response) => {
      console.log("RESPONSE DATA: ", response.data.body)
      const newData = dataSource.filter(item => item.key !== key);
      setDataSource(newData);
      setIsRefreshing(true);
    }).catch((error) => {
      console.log(error);
    });


  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 300000); // Refresh every 5 minutes
    return () => clearInterval(interval);
  }, []);

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : '',
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  

  const columnsDashboard = [
    { title: 'Contact ID', dataIndex: 'ContactID', key: 'ContactID', ...getColumnSearchProps('QueueName'), className: 'column-title' },
    { title: 'Queue Name', dataIndex: 'QueueName', key: 'QueueName', ...getColumnSearchProps('QueueName'), className: 'column-title' },
    { title: "Caller's Phone Number", dataIndex: 'PhoneNumber', key: 'PhoneNumber', ...getColumnSearchProps('PhoneNumber'), className: 'column-title' },
    { title: 'Enqueue Time', dataIndex: 'DateEnqueue', key: 'DateEnqueue', ...getColumnSearchProps('DateEnqueue'), className: 'column-title' },
    { title: 'Caller Position', dataIndex: 'Position', key: 'Position', ...getColumnSearchProps('Position'), className: 'column-title' },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <Popconfirm
          title="Click Yes to submit."
          description="Confirm callback removal."
          onConfirm={() => handleRemove(record.ContactID)}
          okText="Yes"
          cancelText="No"
        >
          <Button type="primary">
            Remove
          </Button>
        </Popconfirm>

      ),
    },
  ];

  return (
    <div style={{ padding: 24, backgroundColor: '#f0f2f5' }}>
      <Card title="Callback Data" hoverable>

      <Table

        rowClassName={(_, index) => index % 2 === 0 ? 'table-row-light' : 'table-row-dark'}
        columns={columnsDashboard} dataSource={dataSource} loading={loading} pagination={{ pageSize: 5, showSizeChanger: false, hideOnSignlePage: true }} />
      <Form.Item>
        <Space>
          <Button htmlType="button" onClick={() => { setIsRefreshing(true) }}>
            Refresh Callback Data
          </Button>
        </Space>
      </Form.Item>

      </Card>
    </div>
  );
};

export default Dashboard;
